<template>
  <div class="squadra-crediti" :class="sizeClass" v-if="id">
    <img class="picture" :src="pic" v-if="pic" />
    <div class="nome-squadra" v-if="!hideName && name">{{ name }}</div>
    <span class="crediti" v-if="showCrediti && creditiToShow !== null">{{ creditiToShow }}</span>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import Vuex from "vuex";

export default {
  name: "squadra-crediti",
  mixins: [mixins],
  props: {
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
    crediti: {
      type: [Number, String],
      required: false,
      default: null,
    },
    showCrediti: {
      type: Boolean,
    },
    hideName: {
      type: Boolean,
    },
    xxSmall: {
      type: Boolean,
    },
    xSmall: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    medium: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    },
  },
  computed: {
    // thisSquadra() {
    //   return this.asta_squadre[this.id];
    // },
    name() {
      if (this.asta_squadre[this.id]) {
        return this.asta_squadre[this.id].name;
      } else {
        return null;
      }
    },
    creditiToShow() {
      if(this.crediti){
        return this.crediti
      }else if (this.asta_squadre[this.id]) {
        return this.asta_squadre[this.id].crediti;
      } else {
        return null;
      }
    },
    pic() {
      if (this.asta_squadre[this.id]) {
        return this.asta_squadre[this.id].pic;
      } else {
        return null;
      }
    },
    sizeClass() {
      if (this.xxSmall) {
        return "xx-small";
      }
      if (this.xSmall) {
        return "x-small";
      }
      if (this.small) {
        return "small";
      }
      if (this.medium) {
        return "medium";
      }
      if (this.large) {
        return "large";
      }
      return "small";
    },

    ...Vuex.mapGetters(["asta_squadre"]),
  },
};
</script>
<style lang="scss" scoped>
.squadra-crediti {
  display: flex;
  border-radius: 4px;
  position: relative;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.075);
  background: white;
  color: #607d8b;
  cursor: pointer;
  height: 48px;
  width: 48px;
  justify-content: center;
  &.xx-small {
    height: 32px;
    width: 32px;
    img {
      // border: 2px solid white;
    }
    .nome-squadra {
      bottom: 2px;
      font-size: 8px;
      border-radius: 4px;
      padding: 0px;
    }
    .crediti {
      width: 15px;
      height: 15px;
      top: -4px;
      right: -4px;
      font-size: 8px;
    }
  }
  &.x-small {
    height: 40px;
    width: 40px;
    .crediti {
      width: 15px;
      height: 15px;
      top: -4px;
      right: -8px;
      font-size: 8px;
    }
  }
  &.medium {
    height: 65px;
    width: 65px;
  }
  &.large {
    height: 80px;
    width: 80px;
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    // border: 3px solid white;
  }
  .nome-squadra {
    position: absolute;
    width: 90%;
    bottom: 2px;
    background: rgb(0 0 0 / 60%);
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    border-radius: 100px;
    text-align: center;
    line-height: 12px;
    font-size: 8px;
    text-transform: none;
    letter-spacing: normal;
    padding: 2px;
  }
  .crediti {
    position: absolute;
    width: 20px;
    height: 20px;
    right: -8px;
    font-size: 9px;
    top: -4px;
  }
}
</style>
